import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { shippingLabelFormatOptions } from './constants'

const ShippingLabelFormat = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Formato de etiqueta')}
      menuItems={shippingLabelFormatOptions.map(option => ({ ...option, label: t(option.label) }))}
      value={value}
      handleChange={e => onChange('label_format', e.target.value)}
      helperText={t('PDF recomendado para impresoras estándar, ZPL para impresoras de papel térmico')}
    />
  )
}

export default ShippingLabelFormat
